/**
 * @generated SignedSource<<ea5d5a81b516ed3319b00432dff782a9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type VideoGenerationInput = {
  aspectRatio?: string | null;
  customPrompt?: string | null;
  durationSeconds: number;
  effectPreset?: string | null;
  generateAudio?: boolean | null;
  imageUrl: string;
  model: string;
  resolution?: string | null;
  saveToLibrary: boolean;
  videoPreset?: string | null;
};
export type tasksStartVideoGenerationMutation$variables = {
  input: VideoGenerationInput;
};
export type tasksStartVideoGenerationMutation$data = {
  readonly startVideoGeneration: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartVideoGenerationMutation = {
  response: tasksStartVideoGenerationMutation$data;
  variables: tasksStartVideoGenerationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VideoGenerationTask",
    "kind": "LinkedField",
    "name": "startVideoGeneration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartVideoGenerationMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "tasksStartVideoGenerationMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "68c4b1b5d982b69e4de40ac6e2fc6865",
    "id": null,
    "metadata": {},
    "name": "tasksStartVideoGenerationMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartVideoGenerationMutation(\n  $input: VideoGenerationInput!\n) {\n  startVideoGeneration(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "97d3e6f0b2a8ed442a6d102ec9111c1e";

export default node;
